import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

// Stamped into index.html when the image is built. Absent when Vite serves the app in dev, which
// leaves the check off.
const ownBuild =
    document.querySelector('meta[name="app-build"]')?.getAttribute('content') ??
    null;

export const useAppVersionStore = defineStore('appVersion', () => {
    const serverBuild = ref<string | null>(null);

    // Front and back ship in the same image: a server build that differs from the one that served
    // this page means the tab is running code the server no longer serves. A backend too old to
    // stamp the header sends none.
    const isOutdated = computed(
        () =>
            ownBuild !== null &&
            serverBuild.value !== null &&
            serverBuild.value !== ownBuild
    );

    const recordServerBuild = (build: string | null) => {
        if (build) {
            serverBuild.value = build;
        }
    };

    return { isOutdated, recordServerBuild };
});
